
import Table from '@material-ui/core/Table'

export default Table